/**
 * Global Listeners Class
 * Handles site-wide event listeners and utilities
 *
 * Global Utilities:
 * - window.QF.initDragScroll(selector) - Adds drag-to-scroll functionality to any horizontal scrolling container
 *   Usage: window.QF.initDragScroll('.tabs ul') or window.QF.initDragScroll('.fmf-modal .tabs ul')
 */
class GlobalListeners {
  constructor() {
    this.selectors = {
      quickAdds: '[quick-add-qf]',
      productForms: '[action="/cart/add"]:not(.ctl-product-form [action="/cart/add"])',
      openSideCart: '.openSideCart',
      closeSideCart: '.closeSideCart',
      itemCard: '.cart .items-wrapper .item',
      removeButtons: '.cart .items-wrapper .remove-item',
      quantitySelectorPlus: '.cart .items-wrapper .quantity-wrapper .plus',
      quantitySelectorMinus: '.cart .items-wrapper .quantity-wrapper .minus',
      cartCount: '.cart-count',
      giftAddToCarts: '[qf-gift-add-to-cart]',
      predictiveSearch: '.predictive-search-container',
    };

    this.init();
    this.initGlobalUtilities();
  }

  init() {
    window.log("Initializing global QF listeners");
    document.body.addEventListener('click', this.handleEvent.bind(this));
    // document.body.addEventListener('change', (e)=>{
    //   if(e.target.closest('[data-change-sub]')){
    //     (async ()=>{
    //       var key = e.target.closest('[data-change-sub]').getAttribute('data-change-sub')
    //       await window.cart.change({
    //         id: key,
    //         selling_plan: parseInt(e.target.value),
    //         properties: {_selling_plan:parseInt(e.target.value)}
    //       })
    //     })()
    //   }
    // });
    document.body.addEventListener('change', (e)=>{
      if(e.target.closest('[data-change-sub]')){
        (async ()=>{
          var key = e.target.closest('[data-change-sub]').getAttribute('data-change-sub');
          var quantityWrapper = e.target.closest('.item').querySelector('.quantity-wrapper');
          var quantity = 1;
          if (quantityWrapper) {
            var quantitySpan = quantityWrapper.querySelector('.quantity span');
            if (quantitySpan) {
              quantity = parseInt(quantitySpan.textContent.trim(), 10) || 1;
            }
          }
          await window.cart.change({
            id: key,
            quantity: quantity,
            selling_plan: parseInt(e.target.value),
            properties: {_selling_plan:parseInt(e.target.value)}
          })
        })()
      }
    });
    this.productForm();
    this.cartRelated();
    this.headerSearch();
    this.mobileMenu();
    this.sideCartTabs();
    this.openFmfModal();
    this.giftAddToCart();
    this.showBabPromotionBanner();

    // Check scroll
    function checkScroll() {
      const scrollPosition = window.scrollY;

      if (scrollPosition > 30) {
        document.body.classList.add('scrolled');
      } else {
        document.body.classList.remove('scrolled');
      }
    }
    window.addEventListener('scroll', checkScroll);
  }

  // handleEvent(e) {
  //   this.productQuickAdd(e);
  //   this.siteCart(e);
  //   this.quantityButtons(e);
  //   this.removeCartItem(e);
  //   if(e.target.closest('[data-swap-prod]')){
  //     (async ()=>{
  //       var json = JSON.parse(e.target.closest('[data-swap-prod]').getAttribute('data-swap-prod'))
  //       var item = {
  //         id: json[1],
  //         quantity: json[2],
  //       }
  //       if(json[3] != ''){
  //         item.selling_plan = parseInt(json[3])
  //         item.properties = {_selling_plan:json[3]}
  //       }
  //       await window.cart.remove(json[0])
  //       await window.cart.add({
  //         items: [item]
  //       })
  //     })()
  //   }
  //   if(e.target.closest('[data-apply-sub]')){
  //     (async ()=>{
  //       var json = JSON.parse(e.target.closest('[data-apply-sub]').getAttribute('data-apply-sub'))
  //       await window.cart.change({
  //         id: json[0],
  //         selling_plan: json[1],
  //         properties: {_selling_plan:json[1]}
  //       })
  //     })()
  //   }
  // }

  handleEvent(e) {
    this.productQuickAdd(e);
    this.siteCart(e);
    this.quantityButtons(e);
    this.removeCartItem(e);

    const getCart = async () => {
      const res = await fetch('/cart.js');
      return await res.json();
    };

    if (e.target.closest('[data-swap-prod]')) {
      (async () => {
        const btn = e.target.closest('[data-swap-prod]');
        const json = JSON.parse(btn.getAttribute('data-swap-prod'));

        // Get current cart and find quantity for old item
        const cart = await getCart();
        const oldLineItem = cart.items.find(item => item.key === json[0]);
        const quantity = oldLineItem ? oldLineItem.quantity : parseInt(json[2], 10) || 1;

        const item = {
          id: json[1],
          quantity: quantity,
        };

        if (json[3] !== '') {
          item.selling_plan = parseInt(json[3]);
          item.properties = { _selling_plan: json[3] };
        }

        await window.cart.remove(json[0]);
        await window.cart.add({ items: [item] });
      })();
    }

    if (e.target.closest('[data-apply-sub]')) {
      (async () => {
        const btn = e.target.closest('[data-apply-sub]');
        const json = JSON.parse(btn.getAttribute('data-apply-sub'));

        const cart = await getCart();
        const lineItem = cart.items.find(item => item.key === json[0]);
        const quantity = lineItem ? lineItem.quantity : 1;

        await window.cart.change({
          id: json[0],
          quantity: quantity,
          selling_plan: json[1],
          properties: { _selling_plan: json[1] }
        });
      })();
    }

  }

  productQuickAdd(e) {
    // PRODUCT QUICK ADD
    const quickAdd = e.target.closest(this.selectors.quickAdds);
    if (quickAdd) {
      e.preventDefault();
      const quantity = parseInt(quickAdd.dataset.quantity);
      if (quickAdd.dataset.id && quantity > 0) {
        const item = { id: quickAdd.dataset.id, quantity };
        const compareAt = quickAdd.dataset.compareAtPrice;
        if (compareAt && compareAt !== '' && !isNaN(parseFloat(compareAt))) {
          item.properties = { "_compare_at_price": parseFloat(compareAt).toFixed(2) };
        }
        window.cart.add({ items: [item] });
      }
    }
  }

  productForm() {
    // PRODUCT FORM LISTENER
    const productForms = document.querySelectorAll(this.selectors.productForms);
    if (productForms.length > 0) {
      productForms.forEach(productForm => {
        productForm.addEventListener("submit", e => {
          e.preventDefault();
          const quantity = productForm.querySelector("input.quantity-selector").value;
          const id = productForm.querySelector("#product-id").value;

          // Check if subscription is selected
          const isSubscription = productForm.querySelector("#purchase-subscription")?.checked || false;

          // Get selling plan select element
          const sellingPlanSelect = productForm.querySelector("#selling_plan_select");

          // Helper to get compare at price based on current selection
          const getCompareAtPrice = () => {
            let detectedCompare = null;
            const selectedVariantRadio = productForm.querySelector('.variant-size-radio:checked');
            const variantId = selectedVariantRadio ? selectedVariantRadio.value : null;
            const isSub = isSubscription;
            if (!isSub) {
              if (selectedVariantRadio && selectedVariantRadio.dataset && selectedVariantRadio.dataset.variantComparePrice) {
                const val = parseFloat(selectedVariantRadio.dataset.variantComparePrice / 100);
                console.log("val", val)
                if (!isNaN(val)) detectedCompare = val.toFixed(2);
              }
              if (!detectedCompare && variantId) {
                const wasPriceEl = document.querySelector(`#one-time-price-display .variant-price-container[data-variant-id="${variantId}"] .was-price`);
                if (wasPriceEl && wasPriceEl.textContent) {
                  console.log("onetime", wasPriceEl, wasPriceEl.textContent)
                  const parsed = parseFloat(wasPriceEl.textContent.replace(/[^0-9.-]+/g, ''));
                  console.log("onetime parsed", parsed,)
                  if (!isNaN(parsed)) detectedCompare = parsed.toFixed(2);
                }
              }
            } else if (variantId) {
              const wasPriceEl = document.querySelector(`#subscription-price-display .variant-price-container[data-variant-id="${variantId}"] .was-price`);
              if (wasPriceEl && wasPriceEl.textContent) {
                const parsed = parseFloat(wasPriceEl.textContent.replace(/[^0-9.-]+/g, ''));
                if (!isNaN(parsed)) detectedCompare = parsed.toFixed(2);
              }
            }
            return detectedCompare;
          };

          // Check if we're in subscription mode and the select isn't disabled
          if (isSubscription && sellingPlanSelect && !sellingPlanSelect.disabled) {
            const sellingPlanId = sellingPlanSelect.value;

            if (quantity && id && sellingPlanId) {
              console.log('Adding subscription item:', id, quantity, sellingPlanId);

              // Add to cart with selling plan
              const cap = getCompareAtPrice();
              const props = { "_selling_plan": sellingPlanId };
              if (cap) props["_compare_at_price"] = cap;
              window.cart.add({ items: [{ id, quantity, selling_plan: sellingPlanId, properties: props }] });
            }
          } else {
            // One-time purchase
            if (quantity && id) {
              console.log('Adding one-time item:', id, quantity);
              const cap = getCompareAtPrice();
              const item = { id, quantity };
              if (cap) item.properties = { "_compare_at_price": cap };
              window.cart.add({ items: [item] });
            }
          }
        });
      });
    }
  }

  giftAddToCart() {
    const giftAddToCarts = document.querySelectorAll(this.selectors.giftAddToCarts);
    giftAddToCarts.forEach(addToCart => {
      addToCart.addEventListener("click", e => {
        e.preventDefault();

        const gift_product_ids = document.querySelectorAll(".recipient-form input[name='selected-gift-products[]']");
        const giftCartItems = [];

        const recipientName = document.querySelector(".recipient-form #recipients-name").value;
        const recipientAddress = document.querySelector(".recipient-form #recipients-address").value;
        const recipientPostcode = document.querySelector(".recipient-form #recipients-postcode").value;
        const recipientMessage = document.querySelector(".recipient-form #recipients-message").value;

        if (!recipientName || !recipientAddress || !recipientPostcode || !recipientMessage) {
          document.querySelector('.modal-form-error').textContent = 'Please fill in all the fields.';
          return;
        }

        gift_product_ids.forEach(idInput => {
          const product_id = idInput.value;
          if (product_id) {
            const giftCartItem = {
              "id": product_id,
              "quantity": 1,
              "properties": {
                "recipient_gift": "yes",
                "recipient_name": recipientName,
                "recipient_address": recipientAddress,
                "recipient_postcode": recipientPostcode,
                "recipient_message": recipientMessage
              }
            };
            giftCartItems.push(giftCartItem);
          }
        });

        // Add all the items to the cart
        if (giftCartItems.length > 0) {
          window.cart.add({ items: giftCartItems });
        }
      });
    });
  }

  siteCart(e) {
    // SITE CART OPEN AND CLOSE
    if (!window.QF.settings.sideCart) return;

    const openSideCart = e.target.closest(this.selectors.openSideCart);
    if (openSideCart) {
      e.preventDefault();
      if (!window.cart.cartOpen) {
        window.cart.openSideCart();
      }
    }

    const closeSideCart = e.target.closest(this.selectors.closeSideCart);
    const sideCartDrawer = document.querySelector('#cart-drawer-container');
    if (window.cart.cartOpen) {
      if (e.target == sideCartDrawer) {
        window.cart.closeSideCart();
      }
    }
    if (closeSideCart) {
      e.preventDefault();
      if (window.cart.cartOpen) {
        window.cart.closeSideCart();
      }
    }
  }

  quantityButtons(e) {
    // QUANTITY PLUS CART
    const quantityPlus = e.target.closest(this.selectors.quantitySelectorPlus);
    if (quantityPlus) {
      if (quantityPlus.getAttribute("data-pending") === "true") return;
      quantityPlus.setAttribute("data-pending", true);

      const quantity = quantityPlus.parentNode.querySelector(".quantity span");
      const stock = quantity.getAttribute("data-stock");
      const variant_id = quantity.getAttribute("data-variant-id");
      const inv_policy = quantity.getAttribute("data-inventory-policy");

      const current = parseInt(quantity.innerHTML);
      if (inv_policy === "continue" || stock > 0) {
        if (current > 0) {
          const updated = current + 1;
          window.cart.update({ updates: { [variant_id]: updated } }, 'plus');
        }
      }
    }

    // QUANTITY MINUS CART
    const quantityMinus = e.target.closest(this.selectors.quantitySelectorMinus);
    if (quantityMinus) {
      if (quantityMinus.getAttribute("data-pending") === "true") return;
      quantityMinus.setAttribute("data-pending", true);

      const quantity = quantityMinus.parentNode.querySelector(".quantity span");
      const current = parseInt(quantity.innerHTML);
      const variant_id = quantity.getAttribute("data-variant-id");

      if (current > 0) {
        const updated = current - 1;
        window.cart.update({ updates: { [variant_id]: updated } }, 'minus');
      }
    }
  }

  removeCartItem(e) {
    // REMOVE ITEM CART
    const itemCard = e.target.closest(this.selectors.itemCard);
    const removeButtons = e.target.closest(this.selectors.removeButtons);
    if (removeButtons) {
      const variant_id = removeButtons.getAttribute("data-variant-id");
      const product_id = itemCard.getAttribute("data-product-id");
      const quantity = itemCard.querySelector('.quantity-wrapper').getAttribute('data-quantity');
      const index = itemCard.getAttribute('data-index');
      const event = new CustomEvent('cart_item_removed', {
        detail: {
          variant_id: variant_id,
          product_id: product_id,
          quantity: quantity,
          index: index
        }
      });
      window.cart.remove(variant_id);
      window.dispatchEvent(event);
    }
  }

  cartRelated() {
    // update side cart/cart after change
    const renderCarts = () => {
      if (window.template === "cart") {
        window.cart.reRenderCart();
      } else {
        if (window.QF.settings.ajax_open_side_cart) {
          window.cart.openSideCart();
        } else if (window.QF.settings.ajax_toast) {
          window.cart.reRenderSideCart();
        }
      }
    };
    window.addEventListener("cart_changed", renderCarts);
    window.addEventListener("item_removed", renderCarts);

    // CART COUNT
    window.addEventListener("cart_changed", e => {
      if (e.detail.cart) {
        const cartCount = document.querySelectorAll(".cart-count");
        cartCount.forEach(count => {
          count.innerHTML = e.detail.cart.item_count;
        });
      }
    });
  }

  headerSearch() {
    const search = document.querySelector('.mega-menu .mega-menu-wrapper .header-search-bar-wrapper');
    const searchTrigger = document.querySelector('.mega-menu .mega-menu-controls [data-open-search]');
    const searchInput = document.querySelector('.mega-menu .mega-menu-wrapper .header-search-bar-wrapper .search-bar-qf input');
    const predictiveSearch = document.querySelector('.predictive-search-container');
    const mobileSearchClose = document.querySelector('.mobile-search-close');

    // Check Search exists
    if (search) {
      // Open / Close Search
      searchTrigger.addEventListener('click', e => {
        e.preventDefault();

        if (searchTrigger.classList.contains('active')) {
          searchTrigger.classList.remove('active');
          search.classList.remove('active');
          predictiveSearch.classList.remove('active');
          searchInput.value = '';
          document.body.classList.remove('fixed');
        } else {
          searchTrigger.classList.add('active');
          search.classList.add('active');
          searchInput.focus();
        }
      });

      // Close mobile
      mobileSearchClose.addEventListener('click', e => {
        e.preventDefault();

        searchTrigger.classList.remove('active');
        search.classList.remove('active');
        predictiveSearch.classList.remove('active');
        searchInput.value = '';
        document.body.classList.remove('fixed');
      });

      // Close search with Escape Key
      window.addEventListener('keydown', e => {
        const key = e.key;

        if (key === 'Escape') {
          if (window.activeElement.classList.contains('header-search')) {
            searchTrigger.classList.remove('active');
            search.classList.remove('active');
          } else {
            return;
          }
        }
      });
    }

  }

  mobileMenu() {
    const menu = document.querySelector('.mobile-menu-outer-wrapper');
    const menuTrigger = document.querySelector('#open-mobile-menu');
    const mobileTrigger = document.querySelector('.search-mobile');
    const searchSideBar = document.querySelector('.predictive-search-container');
    const closeMobileMenu = document.querySelector('.close-mobile-menu');

    if (menuTrigger) {
      menuTrigger.addEventListener('click', () => {

        if (menuTrigger.classList.contains('active')) {
          menu.classList.remove('active');
          menuTrigger.classList.remove('active');
          document.body.classList.remove('fixed');
        } else {
          menu.classList.add('active');
          menuTrigger.classList.add('active');
          document.body.classList.add('fixed');
        }
      });
    }
    if (mobileTrigger) {
      mobileTrigger.addEventListener('click', () => {

        if (mobileTrigger.classList.contains('active')) {
          menu.classList.remove('active');
          menuTrigger.classList.remove('active');
        } else {
          menu.classList.add('active');
          menuTrigger.classList.add('active');
        }
      });
    }
    menu.addEventListener('click', e => {
      if (e.target.classList.contains('mobile-menu-outer-wrapper')) {
        menu.classList.remove('active');
        menuTrigger.classList.remove('active');
        mobileTrigger.classList.remove('active');
        document.body.classList.remove('fixed');
      }
    });

    closeMobileMenu.addEventListener('click', e => {
      if (menuTrigger.classList.contains('active')) {
        menu.classList.remove('active');
        menuTrigger.classList.remove('active');
        mobileTrigger.classList.remove('active');
        document.body.classList.remove('fixed');
      }
      if (searchSideBar.classList.contains('active')) {
        searchSideBar.classList.remove('active');
      }
    });
  }

  sideCartTabs() {
    const cart_tabs = document.querySelectorAll('.cart-tab');

    cart_tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        tab.classList.remove('active');
        if (!e.target.closest('.cart-tab').classList.contains('active')) {
          cart_tabs.forEach(tab => {
            tab.classList.remove('active');
          })
          let tab_selected = e.target.closest('.cart-tab');
          tab_selected.classList.add('active')
          let tab_data = tab_selected.getAttribute('data-tab');
          let cart_contents = document.querySelectorAll('.cart-content');
          cart_contents.forEach(cart_content => {
            cart_content.style.display = 'none';
          })
          document.querySelector('.' + tab_data).style.display = 'flex';
          if (tab_data == 'saved-cart') {
            if (window.wishlist.needsUpdate) {
              window.wishlist.initSideCartGrid();
              window.wishlist.needsUpdate = false;
            }
          }
        }
      })
    })
  }

  openFmfModal() {
    const fmfModal = document.querySelector('.fmf-modal');
    const fmfModalTab = document.querySelector('.fmf-modal .open-fmf');
    const openFmfModal = document.querySelectorAll('[open-fmf-modal], a[href="#fmf-modal"]');
    const closeModal = document.querySelector('.fmf-modal .close-modal');

    let urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has("find-my-food")) {
      const openModalText = "Feeding Advice";
      document.body.classList.toggle('fixed');
      fmfModal.classList.toggle('active');
      if (fmfModalTab.innerHTML == "Close") {
        fmfModalTab.innerHTML = openModalText;
      } else {
        fmfModalTab.innerHTML = "Close";
      }
    }

    let imagesLoaded = false;

    openFmfModal.forEach((open) => {
      open.addEventListener('click', (e) => {
        e.preventDefault();

        // Load images
        if (!imagesLoaded) {
          const images = fmfModal.querySelectorAll('img[data-src]');

          images.forEach(function (image) {
            const src = image.getAttribute('data-src');
            image.setAttribute('src', src);
            image.removeAttribute('data-src');
          });

          imagesLoaded = true;
        }

        const openModalText = open.getAttribute('data-title');
        document.body.classList.toggle('fixed');
        fmfModal.classList.toggle('active');
        if (fmfModalTab.innerHTML == "Close") {
          fmfModalTab.innerHTML = openModalText;
        } else {
          fmfModalTab.innerHTML = "Close";
        }
      })
    })

    if(closeModal) {
      closeModal.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.remove('fixed');
        fmfModal.classList.remove('active');
        fmfModalTab.innerHTML = "Feeding Advice";
      })
    }
  }

  showBabPromotionBanner() {
    if(window.QF.has_had_subscription === false) {
      const babPromotionBanner = document.querySelector('.promotional-bar .promo-bar-content');
      if(babPromotionBanner){
        const babPromotionBannerText = babPromotionBanner.querySelector('.promo-bar-text');
        const babPromotionBannerLink = babPromotionBanner.querySelector('.promo-bar-link');

        const babQualifyOffer = localStorage.getItem('babQualifyOffer');
        const babStage = localStorage.getItem('babStage');

        if (babQualifyOffer === 'true') {
          babPromotionBanner.style.display = 'block';

          if (window.template === 'page.build-a-box') {
            if (babPromotionBannerLink) {
              babPromotionBannerLink.href = '/';
              babPromotionBannerText.innerHTML = 'Take me back to the main site';
            } else {
              babPromotionBannerText.innerHTML = `<a href="/">Take me back to the main site</a>`;
            }
          } else {
            let babUrl = '/pages/build-a-box';
            const babId = localStorage.getItem('babId');
            if (babStage === 'bab-landing') {
              babUrl = '/pages/build-a-box-landing';
            } else if (babStage === 'bab-recommendations') {
              if(babId) {
                babUrl = `/pages/build-a-box?dogId=${babId}`;
              } else {
                babUrl = '/pages/build-a-box';
              }
            }
            if (babPromotionBannerLink) {
              babPromotionBannerLink.href = babUrl;
              babPromotionBannerText.innerHTML = `Unlock our latest offer - Save ${window.QF.buildABox.firstBoxValue}%, ${window.QF.buildABox.secondBoxValue}%, ${window.QF.buildABox.thirdBoxValue}% off Subscriptions`;
            } else {
              babPromotionBannerText.innerHTML = `<a href="${babUrl}">Unlock our latest offer - Save ${window.QF.buildABox.firstBoxValue}%, ${window.QF.buildABox.secondBoxValue}%, ${window.QF.buildABox.thirdBoxValue}% off Subscriptions</a>`;
            }
          }
        }
      }
    }
  }

  // Initialize global utility functions
  initGlobalUtilities() {
    // Global drag scroll utility
    window.QF = window.QF || {};
    window.QF.initDragScroll = (selector) => {
      const tabsList = document.querySelector(selector);
      if (!tabsList) return;

      let isDragging = false;
      let startX, scrollLeft;
      let animationId;
      let dragDistance = 0;
      let startTime;
      let hasDragged = false;
      let dragStartTarget = null;

      const startDragging = (e) => {
        // Don't start dragging on specific interactive elements which should be a click
        if (e.target.closest('[data-create-tab], button:not(.tab-link), a, input, select, textarea')) {
          return;
        }

        isDragging = true;
        hasDragged = false;
        dragStartTarget = e.target;
        startX = e.type === 'mousedown' ? e.pageX - tabsList.offsetLeft : e.touches[0].pageX - tabsList.offsetLeft;
        scrollLeft = tabsList.scrollLeft;
        dragDistance = 0;
        startTime = Date.now();

        tabsList.classList.add('dragging');
      };

      const stopDragging = () => {
        isDragging = false;
        tabsList.classList.remove('dragging');

        if (animationId) {
          cancelAnimationFrame(animationId);
        }

        // Reset drag state after a short delay to allow for click events
        setTimeout(() => {
          hasDragged = false;
          dragDistance = 0;
          dragStartTarget = null;
        }, 200);
      };

      const drag = (e) => {
        if (!isDragging) return;

        const x = e.type === 'mousemove' ? e.pageX - tabsList.offsetLeft : e.touches[0].pageX - tabsList.offsetLeft;
        const walk = x - startX;
        dragDistance = Math.abs(walk);

        // Only prevent default and scroll if we've moved enough to be considered dragging
        if (dragDistance > 8) {
          hasDragged = true;
          e.preventDefault();

          // Use requestAnimationFrame for smooth scrolling
          if (animationId) {
            cancelAnimationFrame(animationId);
          }

          animationId = requestAnimationFrame(() => {
            tabsList.scrollLeft = scrollLeft - walk;
          });
        }
      };

      // Handle click events to prevent selection during drag
      const handleClick = (e) => {
        // Don't prevent clicks on specific interactive elements that should always work
        if (e.target.closest('[data-create-tab], button:not(.tab-link), a, input, select, textarea')) {
          return;
        }

        // Check if we're clicking on a tab link and if we've been dragging
        // For function new-find-my-food.js and passports.js
        // Can add more if needed
        const isTabClick = e.target.closest('[data-change-tab]');

        if (isTabClick && hasDragged && dragDistance > 12) {
          // console.log('Preventing tab switch due to drag:', { dragDistance, hasDragged });
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      };

      // Mouse events
      tabsList.addEventListener('mousedown', startDragging);
      document.addEventListener('mousemove', drag);
      document.addEventListener('mouseup', stopDragging);

      // Touch events for mobile
      tabsList.addEventListener('touchstart', startDragging, { passive: false });
      document.addEventListener('touchmove', drag, { passive: false });
      document.addEventListener('touchend', stopDragging);

      // Prevent default drag behavior on images
      tabsList.addEventListener('dragstart', (e) => e.preventDefault());

      // Add click handler to prevent selection during drag
      tabsList.addEventListener('click', handleClick, true);

      // Set initial drag-scroll class
      tabsList.classList.add('drag-scroll');
    };
  }
}

window.GlobalListeners = GlobalListeners;
